import React from "react";

export default () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.84364 0L7.08388 1.68169L11.9278 6.3107L0 6.3107L0 8.68896L11.9281 8.68896L7.08388 13.3183L8.84364 15L14.7891 9.30546C15.8168 8.32117 15.8168 6.67883 14.7891 5.69454L8.84364 0Z"
      fill="#008CFF"
    />
  </svg>
);
